function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}var supportedLanguages = ['be', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'es-AR', 'es-ar', 'es-MX', 'es-mx', 'et', 'fi', 'fil', 'fr', 'hr', 'hu', 'id', 'it', 'ja', 'kk', 'ko', 'lt', 'lv', 'ms', 'nl', 'no', 'pl', 'pt', 'pt-BR', 'pt-br', 'ro', 'ru', 'sr', 'sv', 'th', 'tr', 'uk', 'vi', 'zh-CN', 'zh-cn', 'zh-SG', 'zh-sg', 'zh-TW', 'zh-tw'];
var DEFAULT_LANGUAGE = 'en';
var getCurrentLanguage = function getCurrentLanguage() {
  var navigatorLanguages = [window.navigator.language].concat(_toConsumableArray(window.navigator.languages || [])).map(function (language) {
    return language && language.toLowerCase().replace('_', '-');
  });
  var languageCode = navigatorLanguages.find(function (language) {
    return supportedLanguages.includes(language);
  });
  return languageCode || DEFAULT_LANGUAGE;
};
var isChineseLanguage = function isChineseLanguage(language) {
  return language.startsWith('zh');
};var Realms;

(function (Realms) {
  Realms["RU"] = "ru";
  Realms["EU"] = "eu";
  Realms["NA"] = "na";
  Realms["CT"] = "ct";
  Realms["KR"] = "kr";
  Realms["ASIA"] = "asia";
  Realms["CHINESE"] = "cn";
  Realms["CN360"] = "cn360";
})(Realms || (Realms = {}));function isChineseRealm(realm) {
  return realm.toLowerCase().startsWith(Realms.CHINESE);
}export{DEFAULT_LANGUAGE,Realms,getCurrentLanguage,isChineseLanguage,isChineseRealm};//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wotfe/l10n/dist/index.esm.js
// module id = 1864
// module chunks = 16